<template>
	<div ref="subnavBarRef">
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { mutations } from "@js/vue/store.js";
import { onResize, onScroll } from "@js/throttle.js"

const subnavBarRef = ref(null)

const getSubnavBarHeight = () => {
	let height = subnavBarRef.value.getBoundingClientRect().height
	let top = subnavBarRef.value.getBoundingClientRect().top
	return Math.max(0, height + top)
}

onMounted(() => {
	mutations.changeSubnavBarHeight(getSubnavBarHeight());
})

onResize(() => {
	mutations.changeSubnavBarHeight(getSubnavBarHeight());
});

onScroll(() => {
	mutations.changeSubnavBarHeight(getSubnavBarHeight());
});
</script>
